import {createI18n} from "vue-i18n"

const locales = [
    "ko",       //대한민국
    "ar",       //아랍권(사우디, 이집트)
    "cs",       //체코
    "de",       //독일
    "en",       //미국 / 영국
    "fr",       //프랑스
    "es",       //스페인 / 라틴 아메리카
    "it",       //이탈리아
    "ja",       //일본
    "kk",       //카자흐스탄
    "pt",       //포르투칼 / 브라질
    "ru",       //러시아
    "sk",       //슬로바키아
    "sv",       //스웨덴
    "pl",       //폴란드
    "nl",       //네덜란드
    "ro",       //루마니아
    "hu",       //헝가리
    "cy",       //웨일스(영국)
    "fi",       //핀란드
    "da",       //덴마크
    "vi",       //베트남
    "he",       //이스라엘(히브리)
    "sh",       //세르비아(키릴)
    "sr",       //세르비아(라틴)
    "hr",       //크로아티아
    "hi",       //인도(힌디어)
    "kn",       //인도(칸나다어)
    "ml",       //인도(말라얄람어)
    "mr",       //인도(마라티어)
    "ta",       //인도(타밀어)
    "te",       //인도(텔루구어)
]

const easyLocales = locales // 전체 로케일에서 easy/text.json 로드

const messages = locales.reduce((accumulator, locale) => {
    accumulator[locale] = {
        ...require(`@/locale/${locale}/menu.json`),
        ...require(`@/locale/${locale}/label.json`),
        ...require(`@/locale/${locale}/message.json`),
        ...require(`@/locale/${locale}/canvas.json`),
        ...require(`@/locale/brailleLang.json`),
    }
    
    if (easyLocales.includes(locale)) {
        accumulator[locale] = {
            ...accumulator[locale],
            ...require(`@/locale/${locale}/easy/text.json`),
        }
    }
    
    return accumulator
}, {})

export const i18n = new createI18n({
    locale: "en", // set locale
    fallbackLocale: "en", // set fallback locale
    messages,
    legacy: false,
})

